module.exports = __webpack_public_path__ + "static/fh-aba41de8779b373fa687a22eeb9d8b9a.jpg";